// eslint-disable-next-line
// import fromEntries from 'fromentries';
import Vue from 'vue';
import VueI18n from 'vue-i18n';
import URI from 'urijs';

import Locale from '@/config/locale';
import zhMO from './lang/zh';
import enUS from './lang/en';

Vue.use(VueI18n);

// 默认语言
let locale = Locale.ZH_MO;
// let locale = Locale.EN_US;

const url = new URI(location.href);
const searchObj = url.search(true);

if (searchObj && searchObj.locale) {
  locale = searchObj.locale.split('/')?.[0] || Locale.ZH_MO;
}

const i18n = new VueI18n({
  locale,
  messages: {
    [Locale.ZH_MO]: zhMO,
    [Locale.EN_US]: enUS,
  },
});

export default i18n;
